import {Badge} from "@mantine/core";
import {
    Price,
    PriceStatus
} from "../types.ts";

export const PriceStatusBadge = ({record}: { record: Price }) => {
    let color = '';
    if (record.priceStatus === PriceStatus.Active) {
        color = 'green';
    } else if (record.priceStatus === PriceStatus.Inactive) {
        color = 'gray';
    }
    return <Badge color={color}>{record.priceStatus}</Badge>;
};
